export class PaginationCalculation {

	vectorHalf: number
	vectorCap: number // 4 nr de pagini afisate
	pagesCap: number // 22 nr maxim de pagini

	navVector: Array<number> = new Array()
	curPage: number // pagina curenta
	elmIndex: number

	constructor(vectorCap, pagesCap, curPage) {
		this.build(vectorCap, pagesCap, curPage)
	}

	private prepareInputs() {
		if (this.vectorCap % 2 === 0) {
			this.vectorCap--
		}
		if (this.curPage > this.pagesCap) {
			this.curPage = this.pagesCap
		} else if (this.curPage < 1) {
			this.curPage = 1
		}
		if (this.vectorCap > this.pagesCap) {
			this.vectorCap = this.pagesCap
		}

		// totul este ok
		this.vectorHalf = Math.floor(this.vectorCap / 2) // mijlocul vectorului
		this.navVector = [] // new vector
	}

	private calVec() {
		if (this.curPage <= this.vectorHalf) {
			this.elmIndex = this.curPage
		} else if (this.curPage > this.pagesCap - this.vectorHalf) {
			this.elmIndex = this.vectorCap - (this.pagesCap - this.curPage)
		} else {
			this.elmIndex = this.vectorHalf + 1
		}

		this.navVector[0] = this.curPage - this.elmIndex + 1

		for (var j = 1; j < this.vectorCap; j++) {
			this.navVector[j] = this.navVector[j - 1] + 1
		}
	}

	build(vectorCap, pagesCap, curPage) {
		this.vectorCap = vectorCap
		this.pagesCap = pagesCap
		this.curPage = curPage

		this.prepareInputs()
		this.calVec()
		//this.navVector[this.elmIndex - 1] = "*"
	}
}
